import React, { forwardRef, ReactNode, SyntheticEvent } from 'react';
import styled from 'styled-components';
import { optionHover } from '../../../../styles/shareableStyles';
import SwitchiOS from '../../../SwitchiOS';
import { theme } from '../../../../styles/theme';

interface IProps {
  children: ReactNode;
  onClick: (event: SyntheticEvent) => void;
  isChecked: boolean;
  hasCustomColor?: boolean;
}

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 28px;
  padding-right: 9px;
  padding-left: 9px;
  &:hover {
    cursor: pointer;
    ${optionHover};
  }
  &:first-child {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }
  &:last-child {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }
`;

const ChartOptionsSwitch = forwardRef<HTMLDivElement, IProps>(
  ({ children, onClick, isChecked, hasCustomColor }, ref) => (
    <Container
      ref={ref}
      onClick={onClick}
      style={
        isChecked && !hasCustomColor
          ? { color: theme.colors.mainBlue }
          : undefined
      }
    >
      {children}
      <SwitchiOS isChecked={isChecked} />
    </Container>
  ),
);

export default ChartOptionsSwitch;
